import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  updateDoc
} from 'firebase/firestore';
import { db } from '../config/firebase';

class AlbumBookService {
  async getAlbumPages(bookId) {
    const pagesRef = collection(db, 'pb-books', bookId, 'album-pages');
    try {
      const snapshot = await getDocs(query(pagesRef, orderBy('updatedAt', 'desc')));
      return snapshot.docs.map((pageDoc) => ({ id: pageDoc.id, ...pageDoc.data() }));
    } catch (error) {
      const fallbackSnapshot = await getDocs(pagesRef);
      return fallbackSnapshot.docs.map((pageDoc) => ({ id: pageDoc.id, ...pageDoc.data() }));
    }
  }

  async createAlbumPage(bookId, pageData) {
    const pagesRef = collection(db, 'pb-books', bookId, 'album-pages');
    const docRef = await addDoc(pagesRef, {
      ...pageData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return docRef.id;
  }

  async updateAlbumPage(bookId, pageId, pageData) {
    const pageRef = doc(db, 'pb-books', bookId, 'album-pages', pageId);
    await updateDoc(pageRef, {
      ...pageData,
      updatedAt: serverTimestamp()
    });
  }

  async deleteAlbumPage(bookId, pageId) {
    const pageRef = doc(db, 'pb-books', bookId, 'album-pages', pageId);
    await deleteDoc(pageRef);
  }

  async getAlbumBooks(bookId) {
    const booksRef = collection(db, 'pb-books', bookId, 'album-books');
    try {
      const snapshot = await getDocs(query(booksRef, orderBy('updatedAt', 'desc')));
      return snapshot.docs.map((bookDoc) => ({ id: bookDoc.id, ...bookDoc.data() }));
    } catch (error) {
      const fallbackSnapshot = await getDocs(booksRef);
      return fallbackSnapshot.docs.map((bookDoc) => ({ id: bookDoc.id, ...bookDoc.data() }));
    }
  }

  async createAlbumBook(bookId, bookData) {
    const booksRef = collection(db, 'pb-books', bookId, 'album-books');
    const docRef = await addDoc(booksRef, {
      ...bookData,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    });
    return docRef.id;
  }

  async updateAlbumBook(bookId, albumBookId, bookData) {
    const bookRef = doc(db, 'pb-books', bookId, 'album-books', albumBookId);
    await updateDoc(bookRef, {
      ...bookData,
      updatedAt: serverTimestamp()
    });
  }

  async deleteAlbumBook(bookId, albumBookId) {
    const bookRef = doc(db, 'pb-books', bookId, 'album-books', albumBookId);
    await deleteDoc(bookRef);
  }
}

export const albumBookService = new AlbumBookService();
export default albumBookService;
